module.exports = __webpack_public_path__ + "static/media/logo.e5a59e99.svg";